import { usePage } from "@inertiajs/react"

import type { SharedProps } from "@/types"

import RebulkLogo from "./rebulk-logo"
import RebulkWordmark from "./rebulk-wordmark"

// Mirrors <OrgLogo>: the expanded sidebar shows the full wordmark, the
// collapsed (icon) rail shows just the square mark. Both follow
// `text-black dark:text-white`, so the lettering inverts for dark mode the
// same way the square logo does.
export default function AppLogo() {
  const { props } = usePage<SharedProps>()
  if (props.organization?.partner) return null

  return (
    <div className="flex h-10 w-full items-center justify-start overflow-hidden group-data-[collapsible=icon]:w-8">
      <RebulkWordmark className="h-8 w-auto max-w-none shrink-0 text-black group-data-[collapsible=icon]:hidden dark:text-white" />
      <RebulkLogo className="hidden size-8 text-black group-data-[collapsible=icon]:block dark:text-white" />
    </div>
  )
}
